<template>
    <div>

        <div class=" mt-20">
                <div class=" w-1/2 m-auto lg:w-4/5">
                    <div>
                        <p class=" text-center font-medium font-poppins text-3xl  m-auto lg:w-full md:text-xl">Trusted by a large number of happy Customers Nationwide. </p>
                        <div class=" mt-10 font-poppins text-center lg:w-full">
                            <p>
                                These are the stories of our customers who have joined us with great pleasure when using our services.
                            </p>
                        </div>
                    </div>    
                </div>
            </div>
        <div class=" relative mt-20 font-poppins flex justify-evenly mb-10 md:flex-col " >
            <div v-for="review in reviews" :key="review"   class=" border w-1/4 p-6 border-blue-500 rounded-lg md:w-4/5 md:m-auto md:mt-2">
                
                <div class=" flex justify-between">
                    <div class=" flex">
                        <div>
                            <img class="w-6 h-6 " :src="review.userimage" >
                        </div>
                        <div class=" ml-4">
                            <p class=" font-semibold"></p>
                            <p class=" text-gray-500">{{review.state}}, {{review.country}}</p>
                        </div>
                    </div>

                    <div class=" mr-4">
                        <div class=" flex">
                            <p class="mr-3">{{review.star}}</p>
                            <img class="w-5 h-5" src="../Images/star.png" alt="star">
                        </div>
                    </div>
                </div>
                <div class=" mt-2">
                    <p class="mt-2 mb-2 text-blue-600"> {{review.username}} </p>
                    <p>
                        {{review.comment}}

                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import {baseUrl} from '../../../Config';
const url = baseUrl;
export default {
    data() {
        return {
            reviews : []
        }
    },

    mounted() {
        this.getReviews()
    },


    methods: {
        
        getReviews() {
             axios({
                method: 'GET',
                url: `${url}/v1/web/reviews?sortBy=name&limit=20`,
                headers: {
                    'Content-type': 'application/json',
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
            })
            .then((response) => {
                let review = response.data.data.results;
                this.reviews = review.slice(-3)
            })
            .catch((error) => {
                console.log(error)
            })
        }
    }
}
</script>